import { useContext } from 'react';
import AccountModalTab from '~/constants/accountModalTab';
import UserContext, { useUserData } from '~/contexts/UserContext';
import {
  getCloseAccountModal,
  getOpenAccountModal
} from './headerAccountModalHelpers';

const useCustomHeaderEvents = (
  headerModalTitle,
  initialTab,
  callerIdentifier,
  successHandler
) => {
  const { triggerFetchUserProfile } = useContext(UserContext);
  const closeModal = getCloseAccountModal();

  const handleSuccess = async () => {
    if (successHandler) {
      await successHandler();
    } else {
      triggerFetchUserProfile();
    }
    closeModal();
  };

  const eventPayload = {
    bubbles: true,
    detail: {
      callerIdentifier,
      modalTitle: headerModalTitle,
      onSuccess: () => handleSuccess()
    }
  };

  return getOpenAccountModal(
    eventPayload,
    initialTab === AccountModalTab.CreateAccount
  );
};

type OwnProps = {
  callerIdentifier: string;
  headerModalTitle: string;
  modalLink: string;
  openModal: (() => void) | null;
  router: Record<string, any>;
  successHandler: (() => void) | null;
  tab: AccountModalTab;
};

export default function useHeaderAccountModal({
  callerIdentifier = 'SearchAlert',
  headerModalTitle = 'SAVE YOUR SEARCH',
  openModal = null,
  successHandler = null,
  tab = AccountModalTab.SignIn
}: Partial<OwnProps> = {}) {
  const { isLoggedIn } = useUserData();
  const openHeaderModal = useCustomHeaderEvents(
    headerModalTitle,
    tab,
    callerIdentifier,
    successHandler
  );

  return () => {
    if (!isLoggedIn) {
      openHeaderModal();

      return;
    }

    if (openModal) {
      openModal();

      return;
    }
  };
}
